import { useAppDispatch } from "index";

import { useTheme } from "@mui/material/styles";
import ListItemText from "@mui/material/ListItemText";
import Tooltip from "@mui/material/Tooltip";

import { ColorToggleItem, FilterType } from "@store/filters/types";
import { selectCategory } from "@store/filters/actions";
import useTranslations from "containers/hooks/useLanguageHook";
import { FileCategory } from "constants/filenames";
import { Category } from "fileParsing/types";
import { Box, Grid, ListItemButton, Typography } from "@mui/material";

function CategoryFilterSelector({ items, type }: { items: ColorToggleItem[]; type: FilterType }) {
  const dispatch = useAppDispatch();
  const { t } = useTranslations();
  const theme = useTheme();

  return (
    <Grid
      container
      wrap="wrap"
      columnSpacing={0}
      columnGap={1}
      rowGap={1}
      paddingX={0.5}
      justifyContent="center"
      justifyItems="center"
    >
      {items.map((item: ColorToggleItem) => renderColorItem(item))}
    </Grid>
  );

  function getLabel(item: ColorToggleItem): string {
    if (type === FilterType.fileTypes) return t.FileCategories[item.key as FileCategory];
    if (type === FilterType.categories) return t.Categories[item.key as Category];
    // We dont know what it is
    return "TODO, unknown label";
  }

  function getColor(item: ColorToggleItem): string {
    if (type === FilterType.fileTypes) return theme.palette.files[item.key as FileCategory].main;
    if (type === FilterType.categories) return theme.palette.categories[item.key as Category].main;
    return theme.palette.secondary.main;
  }

  function renderColorItem(item: ColorToggleItem) {
    return (
      <Tooltip
        key={item.id}
        placement="left"
        title={<Typography>{item.value ? t.Vis.ClickCategoryHide : t.Vis.ClickCategoryShow}</Typography>}
      >
        <ListItemButton
          onClick={() => dispatch(selectCategory(type, item.id))}
          dense={true}
          style={{
            padding: 0,
            margin: 0,
            flexGrow: 0,
            backgroundColor: item.value ? getColor(item) : "transparent",
            borderColor: getColor(item),
            borderRadius: 9999,
            borderWidth: 2,
            borderStyle: "solid",
            color: item.value ? "#101010" : theme.palette.text.primary,
          }}
          sx={{
            "&:hover": {
              filter: "brightness(1.2)",
            },
          }}
        >
          <Box
            sx={{
              minWidth: "25px",
              paddingX: 1,
              paddingY: 0.25,
            }}
          >
            <ListItemText
              primary={
                <Typography fontSize="0.9rem" lineHeight={1} fontWeight={item.value ? 600 : 400}>
                  {getLabel(item)}
                </Typography>
              }
            />
          </Box>
        </ListItemButton>
      </Tooltip>
    );
  }
}

export { CategoryFilterSelector };
